import React, { useEffect } from "react"
/*import { Link } from "gatsby"*/
import Menus from "./menus"
import $ from "jquery"
import { isMobile } from "react-device-detect"
import GitHubImages from "../components/GitHubImages"
import NavLinks from  "../components/NavLinks"
import ReactDOM from "react-dom";
import HomePageWithQueryParams from "src/components/HomePageWithQueryParams"
import { BrowserRouter, Route } from 'react-router-dom';
import imagesLoaded from "imagesloaded"

if (typeof window !== "undefined") {
    setInterval(() => {})
  }

  const regexUrlHasQueryParams = /(^https?:\/\/.*)(:\d+|\.com|\.app(\/raid-tier-list|)(\/|))(\/raid-tier-list|)(\/|)(\/\?.*)?$/gim;

function AddHomeOrInnerPageClassToBody() {
    //const [count, setCount] = useState(0);
  
    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
      // Update the document title using the browser API
      // document.title = `You clicked ${count} times`;
      // Manipulate the DOM
      
      if (typeof window !== "undefined") {



        if (window.location.origin + "/raid-tier-list" === window.location.href || window.location.origin + "/raid-tier-list/" === window.location.href) {

            /* $('.ais-ClearRefinements-button').prop('title', 'Please note that this only clears all the filters you currently have selected, it does not reset the search field or the sort order.'); */
            
            $("body").addClass("raid-tier-list")

            ReactDOM.render(
                <BrowserRouter>
                    <Route path="/" component={HomePageWithQueryParams} />
                </BrowserRouter>,
                document.getElementById('ReplacedWith_HomePageWithQueryParams')
            )

        }








        if (window.location.origin + "/" == window.location.href) {
          $("body").addClass("home")
          $("body").removeClass("inner-page")
          /*        $(".item-wrap.notMyChamp").closest(".ais-Hits-item").addClass("notMyChamp")
          $(".item-wrap.myChamp").closest(".ais-Hits-item").addClass("myChamp")*/
        } else {
                //Champ Pages
                if (window.location.href.indexOf("/champions") > -1) {
                    $("body").addClass("champ-page")
                } else {
                    $("body").removeClass("champ-page")
                }
                //News Archive
                if (window.location.href.indexOf("/news") > -1) {
                    $("body").addClass("news-archive")
                } else {
                    $("body").removeClass("news-archive")
                }
                //Tier List Archive
                if (window.location.href.indexOf("/raid/tier-list") > -1) {
                    $("body").addClass("tier-list")
                } else {
                    $("body").removeClass("tier-list")
                }
                //News Pages
                if (window.location.href.indexOf("/news/") > -1) {
                    $("body").addClass("news-page")
                } else {
                    $("body").removeClass("news-page")
                }
                $("body").addClass("inner-page")
                $("body").removeClass("home")
            }
        }

    })
  
    return (
      <>
        {/*      <p>You clicked {count} times</p>
        <button onClick={() => setCount(count + 1)}>
          Click me
        </button>*/}
      </>
    )
  }

class Footer extends React.PureComponent {


    componentDidMount() {
        if (typeof document !== "undefined") {
    
            $(document).click(function (event) {

                if (
                    !$(event.target).closest(".left_slide-in-wrap.key.theKey #menuToggle").length
                  ) {
                    if (
                      !$(".left_slide-in-wrap.key.theKey #menuToggle > input").prop("checked")
                    ) {
                      // If checkbox is not checked...
                      //Do Nothing
                    } else {
                      // If checkbox is checked...
                      $(".left_slide-in-wrap.key.theKey #menuToggle > input").prop(
                        "checked",
                        false
                      ) //uncheck it when clicking outside of it
                    }
                  }

            })

        }
    }


    showCurrentYear() {
        return new Date().getFullYear();
    }
    render() {
        return (
            <footer className="site-footer">
                <div className="footer_inner">
                    <div className="container">
                        <div className="footer-widget footer-content">
                            <section id="nav_menu-8" className="widget widget_nav_menu">
                                <div className="menu-main-container">
                                    <ul id="menu-main" className="menu footer-menu">
                                        <Menus />
                                    </ul>
                                </div>
                            </section>
{/*                            <section id="nav_menu-8" className="widget widget_nav_menu">
                                <div className="menu-main-container">
                                    <ul id="menu-main" className="menu">
                                        <li className="nav-item">
                                            <Link to="/">Categories</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/contact">Contact</Link>
                                        </li>
                                    </ul>
                                </div>
                            </section>*/}
                        </div>
                        <div className="footer-bottom social-right-menu ">
{/*                            <div className="location-info">
                            Chesterfield, MI
                            </div>*/}
                            <div className="site-info">
                                ©{this.showCurrentYear()} Chofly Elite. All rights reserved<br />
                                <br />
                                Designed & Developed by <a href="https://chrismarabate.com" target="_blank" rel="noopener">Chris Marabate</a><br />
                                (Creator of <a href="https://choflyelite-legacy.netlify.com" target="_blank" rel="noopener">RaidChamps.com</a>)
                            </div>
                        </div>
                    </div>
                </div>
                <AddHomeOrInnerPageClassToBody />
            </footer>
        )
    }
}

export default Footer

